import { render, staticRenderFns } from "./OverviewDetail.vue?vue&type=template&id=0cda9aec&scoped=true"
import script from "./OverviewDetail.vue?vue&type=script&lang=js"
export * from "./OverviewDetail.vue?vue&type=script&lang=js"
import style0 from "./OverviewDetail.vue?vue&type=style&index=0&id=0cda9aec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cda9aec",
  null
  
)

export default component.exports